import { syntheticMappedArrays } from '@common/utils'
import {
  MolsonBox,
  MolsonButton,
  MolsonDialog,
  MolsonDialogActions,
  MolsonDialogContent,
  MolsonDialogHeader,
  MolsonTypography
} from '@components/reusable'
import { molsonUseTheme } from '@theme/customMuiExports'
import { useTranslation } from 'react-i18next'

export type ArchivedUnitsProps<T> = {
  archivedItems: T[]
  onClose: () => void
  open: boolean
}

export const ArchivedUnitsModal = <T extends { name?: null | string }>({
  archivedItems = [],
  onClose,
  open
}: ArchivedUnitsProps<T>) => {
  const { t } = useTranslation('', { keyPrefix: 'common' })
  const theme = molsonUseTheme()

  const mappedArchivedItems = syntheticMappedArrays(archivedItems)

  return (
    <MolsonDialog
      dataTestId="archived-units-modal"
      fullWidth={true}
      maxWidth="sm"
      onClose={onClose}
      open={open}
    >
      <MolsonDialogHeader
        dataTestId="archived-units-modal-header"
        headerIcon="WARNING"
        iconColor="warning"
        //@ts-ignore - cannot be null, but the type is not correctly detected in libs.
        subTitle={t('baseUnitsAreAvailable')}
        title={t('archivedItems')}
      />
      <MolsonDialogContent
        sx={{
          p: 0,
          pt: 2
        }}
      >
        <MolsonBox
          bgcolor={theme.palette.secondary[100]}
          borderRadiusType="defaultRounded"
          display="flex"
          flexDirection="column"
          gap={2}
          p={2.5}
        >
          {mappedArchivedItems.map(item => (
            <MolsonTypography key={item.id} py={1} variant="h4">
              {item.name}
            </MolsonTypography>
          ))}
        </MolsonBox>
      </MolsonDialogContent>
      <MolsonDialogActions>
        <MolsonButton
          color="primary"
          fullWidth={true}
          onClick={onClose}
          variant="contained"
        >
          {t('close')}
        </MolsonButton>
      </MolsonDialogActions>
    </MolsonDialog>
  )
}
